(function(algolia) {
  'use strict';

  const englishSortOrder = [
    { key: "recently_ordered_count", title: "Popularity", desc: { active: true, title: "Most popular" } },
    { key: "price", title: "Price", asc: { active: false, title: "Cheapest first" } },
    { key: "price_ratio", title: "Price ratio", asc: { active: false, title: "Highest discount first" } },
    { key: "published_at", title: "Publication date", desc: { active: false, title: "Newest first" } },
    { key: "published_at", title: "Publication date", asc: { active: false, title: "Oldest first" } },
    { key: "vendor", title: "Vendor", desc: { active: false, title: "Vendor Z-A" } },
    { key: "vendor", title: "Vendor", asc: { active: false, title: "Vendor" } },
    { key: "inventory_quantity", title: "Inventory quantity", desc: { active: false, title: "Most available" } },
    { key: "grams", title: "Weight", desc: { active: false, title: "Heaviest first" } },
    { key: "grams", title: "Weight", asc: { active: false, title: "Lightest first" } },
    { key: "title", title: "Name", desc: { active: false, title: "Name Z-A" } },
    { key: "price", title: "Price", desc: { active: false, title: "Most expensive first" } },
    { key: "title", title: "Name", asc: { active: false, title: "Name" } },
  ]

  const frenchSortOrder = [
    { key: "recently_ordered_count", title: "Popularity", desc: { active: true, title: "Le plus populaire" } },
    { key: "price", title: "Price", asc: { active: false, title: "Cheapest first" } },
    { key: "price_ratio", title: "Price ratio", asc: { active: false, title: "Highest discount first" } },
    { key: "published_at", title: "Publication date", desc: { active: false, title: "Newest first" } },
    { key: "published_at", title: "Publication date", asc: { active: false, title: "Oldest first" } },
    { key: "vendor", title: "Vendor", desc: { active: false, title: "Vendor Z-A" } },
    { key: "vendor", title: "Vendor", asc: { active: false, title: "Vendor" } },
    { key: "inventory_quantity", title: "Inventory quantity", desc: { active: false, title: "Most available" } },
    { key: "grams", title: "Weight", desc: { active: false, title: "Heaviest first" } },
    { key: "grams", title: "Weight", asc: { active: false, title: "Lightest first" } },
    { key: "title", title: "Name", desc: { active: false, title: "Name Z-A" } },
    { key: "price", title: "Price", desc: { active: false, title: "Most expensive first" } },
    { key: "title", title: "Name", asc: { active: false, title: "Name" } },
  ]

  const currentSortOrder = Shopify.locale === 'fr' ? frenchSortOrder : englishSortOrder;

  var sort_order_base = algolia.config.index_prefix + 'products';

  algolia.sortOrders = [
    { value: sort_order_base, label: '' + algolia.translations.relevance },
  ];

  currentSortOrder.forEach(function(sort_order) {
    if (
      sort_order.asc &&
      (sort_order.asc.active === true || sort_order.asc.active === '1')
    ) {
      algolia.sortOrders.push({
        value: sort_order_base + '_' + sort_order.key + '_asc',
        label: sort_order.asc.title,
      });
    }

    if (
      sort_order.desc &&
      (sort_order.desc.active === true || sort_order.desc.active === '1')
    ) {
      algolia.sortOrders.push({
        value: sort_order_base + '_' + sort_order.key + '_desc',
        label: sort_order.desc.title,
      });
    }
  });

  // try to fetch sort orders for current collection or fallback to collections default
  var collection_sort_orders =
    algolia.current_collection_id &&
    algolia.config.collection_sort_orders &&
    algolia.config.collection_sort_orders[algolia.current_collection_id]
      ? algolia.config.collection_sort_orders[algolia.current_collection_id]
      : algolia.config.collection_sort_orders &&
        algolia.config.collection_sort_orders.default;

  if (collection_sort_orders) {
    algolia.collectionSortOrders = [
      { value: sort_order_base, label: '' + algolia.translations.relevance },
    ];

    collection_sort_orders.forEach(function(sort_order) {
      if (
        sort_order.asc &&
        (sort_order.asc.active === true || sort_order.asc.active === '1')
      ) {
        algolia.collectionSortOrders.push({
          value: sort_order_base + '_' + sort_order.key + '_asc',
          label: sort_order.asc.title,
        });
      }

      if (
        sort_order.desc &&
        (sort_order.desc.active === true || sort_order.desc.active === '1')
      ) {
        algolia.collectionSortOrders.push({
          value: sort_order_base + '_' + sort_order.key + '_desc',
          label: sort_order.desc.title,
        });
      }
    });
  }
})(window.algoliaShopify);
